/*
 * View for the topic label modal
 */

define([
  "marionette",
  "modules/admin/userAdministration/userDetails/kbSelectDisplay/template/kbSelectTemplate.html",
], function (Marionette, kbSelectTemplate) {
  var KbSelectView = {};

  KbSelectView.kbSelectView = Marionette.ItemView.extend({
    className: "row-fluid",
    //Note that on the template, _.each(items) will go through each item in the collection
    //we are given automatically.  Gnarly!
    template: kbSelectTemplate,
    events: {
      //This will handle changing which KB is selected.  We use JQuery to figure out the ID of the KB
      //whose drop-down entry was selected
      "change #selectKb": function () {
        var kbId = parseInt(this.$el.find("#selectKb option:selected").val(), 10);
        this.trigger("kb:changed", kbId);
      },
    },
  });

  return KbSelectView;
});
